import React from 'react';

import Nose from '../image/nose.jpg';
import Nose1 from '../image/nose4.jpg';
import Nose3 from '../image/nose3.jpg';
import { Link } from 'react-router-dom';
//import AboutDoctor from './../../AboutDoctor';


const FunctionEndoscopic = () => {
  return (
    <>
      <section className="fess-section">
        <style>
          {`
        section {
    position: relative;
    padding: 15px 0px !important;
}
    

#{
    font-family: 'Teachers', sans-serif !important;}


    .doct {
          font-family: 'Teachers', sans-serif !important;
      background-color: #fff;
      margin: 0;
      padding: 0;
    }
      .imge{
      height:480px;}
    .tag {
      background-color: #c7e4f1;
      color: #3a8a8a;
      font-weight: 600;
      font-size: 0.75rem;
      padding: 0.25rem 0.75rem;
      border-radius: 0.25rem;
      display: inline-block;
      margin-bottom: 1rem;
      letter-spacing: 0.02em;
    }
    .btn-readmore {
      background-color: #0F995F;
      color: #fff;
      font-weight: 600;
      font-size: 0.75rem;
      text-transform: uppercase;
      padding: 0.625rem 1.25rem;
      border-radius: 0.25rem;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      border: none;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }
    .btn-readmore:hover, .btn-readmore:focus {
      background-color: #0e6a41;
      color: #fff;
      text-decoration: none;
    }
    .btn-readmore svg {
      stroke: currentColor;
      stroke-width: 3;
      width: 0.75rem;
      height: 0.75rem;
    }
    .text-gray {
      color: #4a4a4a;
       style:"font-size: 1rem; line-height: 1.5";
    }
    .font-semibold {
      font-weight: 700;
    }
    .image-container {
      background-color: #dff3eb;
      border-radius: 0.375rem;
      padding: 1rem;
      max-width: 320px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .image-container img {
      border-radius: 0.375rem;
      width: 100%;
      height: auto;
      object-fit: contain;
      display: block;
      max-height: 400px;
    }
    @media (min-width: 768px) {
      .container-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 5rem;
        max-width: 1200px;
        margin: 4rem auto;
        padding: 0 1.5rem;
      }
      .text-content {
        max-width: 600px;
      }
      .image-container {
        margin: 0;
        max-width: none;
        flex-shrink: 0;
      }
    }
    @media (max-width: 767.98px) {
      .container-flex {
        padding: 2rem 1rem;
      }
    }


   .funct {
          font-family: 'Teachers', sans-serif !important;
      background-color: #fff;
      color: #000;
      padding: 2rem 1rem;
      max-width: auto;
    }
    h2.heading2-font {
      font-weight: 400;
      font-size: 40px;
      line-height: 1.3;
      text-align: center;
      margin-bottom: 2rem;
      font-weight: bold;
    }
      .funct-hed{
      align-items:center;
          align-items: center;
    justify-content: center;
    display: flex;
    
}
      }
    .fonew{
    font-weight:30px;}






    h2.about-fetal-medicine {
      font-weight: 700;
      font-size: 30px;
      margin-bottom: 1rem;
    }
    h2.our-advantage {
      font-weight: 600;
      font-size: 30px;
      margin-bottom: 1.5rem;
    }
    p.text-14px {
      font-size: 14px;
      line-height: 1.5;
    }
    .highlight {
      background-color:white; /* light green */
      color: black; /* dark green */
      font-weight: 600;
      padding: 0 0.15rem;
      border-radius: 0.125rem;
      
    }
    ul.list-unstyled li {
      margin-bottom: 0.75rem;
      display: flex;
      align-items: flex-start;
    }
    ul.list-unstyled li i {
      color: #16a34a; /* bootstrap green */
      margin-right: 0.75rem;
      margin-top: 0.2rem;
      flex-shrink: 0;
    }

  



.frm {
      background-color: white;
      font-family: 'Inter', sans-serif;
      padding: 1rem;
      box-shadow:0 0 8px grey;
      border-radius:10px;
    }
    .appointment-container {
      background-color: #F7FDFA;
      border: 1px solid black;
      border-radius: 0.5rem;
      padding: 1rem 1.5rem;
    
    }


    
    .appointment-container h3 {
      color: black;
      font-weight: 700;
      margin-bottom: 0.25rem;
      user-select: none;
    }
    .form-control {
      background-color: transparent;
      border: 1px solid black;
      color: black;
      font-size: 0.875rem;
      padding-left: 0px 25px;
    }
    .form-control::placeholder {
      color: black;
      opacity: 1;
    }
    .form-control:focus {
      box-shadow: none;
      border-color: black;
      background-color: transparent;
      color: black;
    }
    .input-icon {
      position: absolute;
      left: 0.75rem;
      top: 33%;
      transform: translateY(-50%);
      color: black;
      font-size: 0.875rem;
      pointer-events: none;
    }
    .position-relative {
      position: relative;
    }
    textarea.form-control {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
      resize: none;
    }
    .btn-book {
      background-color: #1B2A5B;
      color: white;
      font-size: 0.75rem;
      font-weight: 600;
      border-radius: 9999px;
      padding: 0.5rem 1.5rem;
      user-select: none;
      border: none;
      width: 100%;
      max-width: 350px;
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
    .btn-book:hover,
    .btn-book:focus {
      background-color: #16234a;
      color: white;
    }
    .form-row-center {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;
      margin-bottom: 1rem;
    }
    .form-row-center > div {
      flex: 1 1 200px;
      max-width: 300px;
    }
      .chos{
      display:flex;
      justify-content:center;
      }

    .accordion-header{
    width:100%;
    font-size:16px;}


    .accordion-button
    {
        font-size: 16px;
        }

      .w-100{
      
          font-family: 'Teachers', sans-serif !important;
      
    }
    .accordion-button {
      font-weight: 600;
      font-size: 0.875rem;
      color: #1f2937; /* Tailwind gray-900 */
    }
    .accordion-button:not(.collapsed) {
      color: #1f2937;
      background-color: #fff;
      box-shadow: 0 1px 3px rgb(0 0 0 / 0.1);
    }
    .accordion-item {
      border-radius: 0.5rem;
      box-shadow: 0 1px 3px rgb(0 0 0 / 0.1);
      margin-bottom: 0.75rem;
      border: none;
      background-color: #fff;
    }
    .accordion-body {
      font-size: 16px;
      color: #4b5563; /* Tailwind gray-700 */
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

    }
    h2 {
      font-weight: 600;
      font-size: 40px;
      margin-bottom: 1.5rem;
      align-center: center !important;
      
    }




 



 .choose {
          font-family: 'Teachers', sans-serif !important;
      background-color: #f4fbf9;
      color: #3f4446;
    }
    .whychooseus-card {
      border-radius: 1rem;
      box-shadow: 0 4px 12px rgb(0 0 0 / 0.1);
      transition: box-shadow 0.3s ease;
      height: 16rem;
      background:white;
    }
    .whychooseus-card:hover {
      box-shadow: 0 8px 24px rgb(0 0 0 / 0.15);
    }
    .whychooseus-icon {
      color: #0D9488;
      font-size: 3rem;
      margin-bottom: 1rem;
    }
    .whychooseus-text {
      font-weight: 500;
      font-size: 0.9rem;
      line-height: 1.3;
    }
      .oseus{
      align-items:center !important;
      display:flex;
      justify-content:center;
      }
      .parme{
      display:flex;
      justify-content:center;}
      .hdfs{
      display:flex;
      justify-content:center;
      }
      
      

















  .funch{
  padding:0;
  
  }
  .foout{
  outline:1px solid;
  height:50px;}
  .fas{
  margin-top:11px;}
  







  

 .frm {
          font-family: 'Teachers', sans-serif !important;
      background-color: #F7FDFA;
      padding: 1.5rem;
    }
    .contact-container {
      background-color: #F7FDFA;
      border-radius: 1rem;
      padding: 2rem 3rem;
      max-width: 960px;
      margin: 0 auto;
      text-align: center;
    }
    .contact-text {
      color: #4a4a4a;
      font-size: 1rem;
      margin-bottom: 1.5rem;
    }
    .contact-text strong {
      font-weight: 700;
    }
    .btn-appointment {
      background-color: #0f8a5f;
      color: white;
      font-size: 1.125rem;
      padding: 0.625rem 3rem;
      border-radius: 50rem;
      border: none;
      transition: background-color 0.3s ease;
    }
    .btn-appointment:hover,
    .btn-appointment:focus {
      background-color: #0d7a52;
      color: white;
    }

.fwis{
font-size:40px;}


.fas{
color:green;}
.fa-solid{
color:green;}

.tsz{
font-size:30px;}



.blc{
font-:20px;
}

.fab{

color:green;}
.faqns{
font-size:40px;}











`}
        </style>
        <div className="container">
          <div className="pq-section pq-style-1 text-center " class="funch">

            <h2 className="pq-section-title" class="hdfs">What is Functional Endoscopic Sinus Surgery (FESS)?</h2>
          </div>

          <p className="cost">
            <b class="blc"> Cost:</b> <span className="highlight">Rs. 60,000/-</span>

          </p>
          <br />

          <div className="content" class="conhf">
            <p>
              Functional Endoscopic Sinus Surgery (FESS) is a minimally invasive procedure used to treat chronic sinus infections and nasal blockages.
            </p>
            <p>
              This procedure uses a thin, flexible tube called an endoscope, which is inserted through the nostrils to provide a clear view of the sinus passages.
            </p>
            <p>
              The goal of FESS is to remove obstructions, restore natural drainage, and improve airflow without external incisions.
            </p>
            <p>
              It is recommended for patients suffering from chronic sinusitis, nasal polyps, or sinus blockages that do not respond to medication.
            </p>
            <p>
              FESS is performed under either local or general anesthesia and typically offers a faster recovery with minimal discomfort compared to traditional sinus surgeries.
            </p>
          </div>
        </div>
      </section>







      <section class="doct">
        <div class="container-flex">

          <div class="text-content  align-items-center">
            <h2>ABOUT THE DOCTOR</h2>
            <p class="text-gray mb-3" >
              MedFirst ENT Centre was established in 1997. Since then it has undergone regular improvements and upgradation to become a centre of excellence for the diagnosis and management of ENT disorders in the NCR. We get patients from all over India and overseas as well. We offer the latest technology and equipment and expertise in the management of ENT diseases.
            </p>
            <p class="text-gray font-semibold mb-4" >
              <strong>Dr. (Major) Rajesh Bhardwaj MBBS (AFMC), MS, DNB, DLO, DHA</strong>
            </p>
            <Link class="btn-readmore" to="/about-doctor-rajesh-bhardwaj/">
              READ MORE
              <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </Link>
          </div>
          <div class="image-container" aria-label="Doctor's portrait background">
            <img src="/static/media/Dr-Rajesh-Bhardwaj..ba39b548b45da76b6b4f.ba39b548b45da76b6b4f.png" alt="Portrait of a serious middle-aged male doctor wearing a green surgical cap and teal scrubs, looking directly at the camera" />
          </div>
        </div>


      </section>










      <section className="left-right-section align-items-center">
        <div className="container" >
          <div className="row">
            <div className="col-xl-6 pe-xl-5">
              <img
                src={Nose}
                className="img-fluid wow fadeInLeft"
                alt="fess-procedure"
              />
            </div>
            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0 " >
              <div className="pq-section pq-style-1 text-left align-items-center">
                <h2 className="fw-bold  font-sans-serif tsz ">Step-by-Step FESS Procedure Explained</h2>
                <p className="pq-section-description">

                  The key steps involved in Functional Endoscopic Sinus Surgery include:
                </p>
                <ul className="pq-section-description">
                  <li>Insertion of the endoscope to visualize sinus passages</li>
                  <li>Removal of polyps, blockages, or infected tissue</li>
                  <li>Enlarging the sinus openings to improve drainage</li>
                  <li>Cleaning out mucus buildup and inflamed tissues</li>
                  <li>Application of a nasal dressing if required</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="left-right-section">
        <div className="container">
          <div className="row">


            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0 d-flex align-items-center">
              <div className="pq-section pq-style-1 text-left ">
                <h2 className="fw-bold font-sans-serif tsz  ">Post-Operative Care After FESS Surgery</h2>
                <p className="pq-section-description">
                  Recovery after FESS is relatively quick, but proper post-operative care is essential:
                </p>
                <ul className="pq-section-description">
                  <li>Avoid strenuous activities for at least a week</li>
                  <li>Use saline nasal sprays as recommended</li>
                  <li>Keep the nasal passages moist</li>
                  <li>Follow up with your ENT specialist for check-ups</li>
                  <li>Watch for any signs of infection or excessive bleeding</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 pe-xl-5">
              <img
                src={Nose1}
                className="img-fluid wow fadeInLeft"
                alt="post-op-care"
              />
            </div>

          </div>
        </div>
      </section>

      <section className="left-right-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 pe-xl-5">
              <img
                src={Nose3}
                className="img-fluid wow fadeInLeft align-items-cente " class="imge"
                alt="complications"
              />
            </div>
            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0  " >
              <div className="pq-section pq-style-1 text-left">
                <h2 className="fw-bold  font-sans-serif tsz">Anesthesia & Safety Measures in Endoscopic Sinus Surgery</h2>
                <ul className="pq-section-description">
                  <li class="gr"><strong>Local Anesthesia:</strong> Numbing of nasal area with medication</li>
                  <li class="gr"><strong>Monitored Anesthesia Care (MAC):</strong> Sedation with IV medications</li>
                  <li class="gr"><strong>General Anesthesia:</strong> Full anesthesia for patient comfort</li>
                </ul>
                <p className="pq-section-description">
                  The choice of anesthesia depends on the patient's condition and surgeon's recommendation.
                </p>
              </div>
              <div className="pq-section pq-style-1 text-left mt-4 pb-0 mb-0">
                <h2 className="fw-bold  font-sans-serif tsz">Possible Complications of Endoscopic Sinus Surgery</h2>
                <br />
                <p className="pq-section-description">
                  Although FESS is generally safe, some potential complications include:
                </p>
                <ul className="pq-section-description">
                  <li class="gr">Bleeding</li>
                  <li class="gr">Infection</li>
                  <li class="gr">Scar tissue formation</li>
                  <li class="gr">Changes in smell sensation</li>
                  <li class="gr">Rare risks like eye or brain complications</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>



      <section class="funct">
        <div className='container'>
          <div class="funct-hed">

            <h2 class="heading2-font align-items-center">
              Endoscopic Sinus Surgery Cost in India – Affordable Options in Delhi NCR
            </h2>
          </div>

          <section>
            
            <p class="text-16px">

              FESS is a minimally invasive surgical technique used to restore normal drainage of the sinuses. Using a small, high-definition endoscope inserted through the nostrils, the ENT surgeon removes blockages such as nasal polyps or inflamed tissue, improving airflow and relieving chronic sinus issues without external incisions.
            </p>
          </section>

          <section class="mt-5">
            <h2 class="our-advantage">
              Key Advantages of Functional Endoscopic Sinus Surgery

            </h2>
            <ul class="list-unstyled">
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">Minimally Invasive:</span>  <p>No visible scars; surgery is done through the nostrils using advanced endoscopic tools.
                </p>  </li>
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">Faster Recovery:</span>  <p>Reduced trauma means quicker healing and minimal downtime.</p>
              </li>
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">Long-Lasting Relief:</span>  <p>Effectively treats chronic sinusitis, nasal congestion, headaches, and infections.
                </p></li>
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">
                  Improved Breathing:</span>  <p>Clears sinus pathways to allow for better nasal airflow.</p>
              </li>
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">Targeted Precision: </span>
                <p> Real-time imaging ensures accurate treatment of affected areas.</p>
              </li>
              <li>
                <i class="fas fa-check-circle"></i>
                <span class="highlight">Outpatient Procedure:</span>
                <p>                Most FESS surgeries are done as day-care procedures—no prolonged hospital stay needed. </p>
              </li>
            </ul>
          </section>
        </div>

      </section>
















     <div class="choose">
  <section class="container py-5 text">
    <h2 class="oseus">Why Choose MedFirst ENT Centre for FESS Surgery?</h2>
    <p class="mb-5 text-secondary mx-auto parme" >
      When it comes to your sinus health, you deserve the best care. Here’s why patients trust us for Functional Endoscopic Sinus Surgery
    </p>
    <div class="row justify-content-center g-4">
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="whychooseus-card flex-fill p-4 d-flex flex-column align-items-center text-center">
          <i class="fas fa-hospital whychooseus-icon"></i>
          <p class="whychooseus-text">
            Fully Equipped ENT Operation Theatre for endoscopic, microscopic, and minimally invasive procedures
          </p>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="whychooseus-card flex-fill p-4 d-flex flex-column align-items-center text-center">
          <i class="fas fa-stethoscope whychooseus-icon"></i>
          <p class="whychooseus-text">
            Specialized Sinus Treatment with Functional Endoscopic Sinus Surgery (FESS).
          </p>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="whychooseus-card flex-fill p-4 d-flex flex-column align-items-center text-center">
          <i class="fas fa-tools whychooseus-icon"></i>
          <p class="whychooseus-text">
            Fully equipped in-house operation theatre with modern endoscopic and microsurgical instruments
          </p>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="whychooseus-card flex-fill p-4 d-flex flex-column align-items-center text-center">
          <i class="fas fa-user-md whychooseus-icon"></i>
          <p class="whychooseus-text">
            Dr. Bhardwaj has over 25 years of experience in ENT care.
          </p>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 d-flex">
        <div class="whychooseus-card flex-fill p-4 d-flex flex-column align-items-center text-center">
          <i class="fas fa-ambulance whychooseus-icon"></i>
          <p class="whychooseus-text">
            24 x 7 Emergency ICU and Critical care Facilities
          </p>
        </div>
      </div>
    </div>
  </section>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
</div>


    <section className="faq">
        <div className="container py-4">
            <div className="row">
                
              <div className="col-md-7">
                <div class="d-flex justify-content-center p-4 ">
                  <div class="container "  >
                    <h2 class="faqns">Frequently Asked Questions</h2>
                    <div class="accordion" id="faqAccordion">
                      <div class="accordion-item rounded">
                        <h2 class="accordion-header hfont " id="headingOne" >
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Is FESS painful?
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse "
                          aria-labelledby="headingOne"
                          data-bs-parent="#faqAccordion"
                        >
                          <div class="accordion-body">
                            FESS is performed under anesthesia, so there is no pain during the surgery. Postoperative discomfort is minimal and manageable with medications.                </div>
                        </div>
                      </div>
                      <div class="accordion-item rounded">
                        <h2 class="accordion-header hfont " id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How long is the recovery time after FESS?                </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#faqAccordion"
                        >
                          <div class="accordion-body">
                            Most patients return to work or normal activities within 5–7 days. Full healing may take a few weeks, depending on the individual.                </div>
                        </div>
                      </div>
                      <div class="accordion-item rounded">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Will I need multiple surgeries?                </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#faqAccordion"
                        >
                          <div class="accordion-body">
                            In most cases, one FESS procedure is sufficient. However, if underlying conditions persist or worsen, a revision may be necessary in the future.                </div>
                        </div>
                      </div>
                      <div class="accordion-item rounded">
                        <h2 class="accordion-header" id="headingFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Are there any risks involved?                </button>
                        </h2>
                        <div
                          id="collapseFour"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#faqAccordion"
                        >
                          <div class="accordion-body">
                            As with any surgery, FESS has some risks, but complications are rare. Our skilled team takes every precaution to ensure safety.                </div>
                        </div>
                      </div>
                      <div class="accordion-item rounded">
                        <h2 class="accordion-header" id="headingFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            How do I know if I’m a candidate for FESS?  </button>
                        </h2>
                        <div
                          id="collapseFive"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#faqAccordion"
                        >
                          <div class="accordion-body">
                            If you suffer from chronic sinusitis, nasal blockages, or recurrent infections that haven’t improved with medications, FESS might be the right option for you. Schedule a consultation to find out.                </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                </div>
				<div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="300px" src="https://www.youtube.com/embed/gAjX8VQoxv8" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                      <div class="p-3"><h5 class="text-success mb-0">How we do Endoscopic Sinus Surgery | SinusTreatment | ENTCare | Sinus relief surgery | ENT In Delhi</h5></div>
				  </div>
              </div>
            </div>
        </div>
    </section>





      <section class="frm container">
        <div class="contact-container ">
        <p class="contact-text">
  Please feel free to contact us at
  <strong><a href="tel:+919205585295"> +91 9205585295 </a></strong> for emergency cases.
</p>

          <Link class="btn btn-appointment" to={'/book-an-appointment'} >
            Book an Appointment
          </Link>
        </div>
      </section>








      <section className="fess-section">
        <div className="container">
          <h2 className="section-title fwis">FESS Surgery with Insurance & Health Policy Support at MedFirst</h2>
          <div className="content conte">
            <p>
              MedFirst ENT Centre ensures a smooth experience for patients undergoing FESS, offering support with insurance claims and third-party administrators (TPA).
            </p>
            <p>
              Patients can check their health insurance policies for coverage options and choose an <Link to="https://entdelhi.com/about-clinic/">ENT clinic</Link> that is part of their insurance network.
            </p>
            <p>
              MedFirst streamlines the claims process, making it easier for patients to receive high-quality care without financial stress.
            </p>
            <p>
              For chronic sinus conditions that require surgical intervention, FESS is a highly effective treatment option that can significantly improve breathing and quality of life.
            </p>
          </div>
        </div>
      </section>

      
    </>
  );
};

export default FunctionEndoscopic;
